import dayjs from 'dayjs'

import { formatDateTimeUk } from '@/Ship/Helpers/fieldViews'

export type ActivityDeadlineTone = 'neutral' | 'warning' | 'error'

/**
 * Чип крайнього терміну в шапці справи (`SPEC-011` §8.4, К-2):
 *
 *  - «07.10.2026, 15:00 · прострочено» — червоний: термін **з часом** уже
 *    настав (предикат П);
 *  - «· сьогодні», «· завтра» — жовтий;
 *  - «· через N дн.» — нейтральний;
 *  - завершена справа — лише дата, без тону.
 *
 * ⚠️ Ship `describeDeadline` рахує дні, а не час (Р4): справа з терміном
 * годину тому була б у нього жовтим «сьогодні» поруч із червоним рядком.
 * Тому тут прострочення — за часом, а «сьогодні/завтра» — за календарним днем.
 */
export const describeActivityDeadline = (
    value: unknown,
    closed = false,
    now: dayjs.ConfigType = undefined
): { text: string; tone: ActivityDeadlineTone } => {
    const date = formatDateTimeUk(value)

    if (date === '—' || closed) return { text: date, tone: 'neutral' }

    const due = dayjs(value as string)
    const current = dayjs(now)

    if (!due.isAfter(current)) return { text: `${date} · прострочено`, tone: 'error' }

    const days = due.startOf('day').diff(current.startOf('day'), 'day')

    if (days === 0) return { text: `${date} · сьогодні`, tone: 'warning' }
    if (days === 1) return { text: `${date} · завтра`, tone: 'warning' }

    return { text: `${date} · через ${days} дн.`, tone: 'neutral' }
}
